<template>
  <p class="margin-bottom-2xl">
    <font-awesome-icon
      :icon="$v6.solid.faHeart"
      size="lg"
      class="margin-right-4xs"
      style="color: var(--fa-red)"
    />
    Sponsored by
    <a
      v-if="sponsorUrl"
      :href="`${sponsorUrl}`"
      target="_blank"
      rel="nofollow"
      style="--link-color: initial"
    >
      {{ sponsorName }}</a
    >
    <template v-else>{{ sponsorName }}</template>
  </p>
</template>
<script>
  export default {
    name: 'IconSponsorship',

    props: {
      sponsorName: {
        type: String
      },
      sponsorUrl: {
        type: String
      }
    }
  }
</script>
